import { z } from 'zod';

import { TeamSchema, Team } from './Team';

export const baseUserSchema = z.object({
    id: z.string(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    name: z.string().optional(),
    email: z.string().toLowerCase().email(),
    source: z.string().optional(),
    developer: z.boolean().optional(),
    internal: z.boolean().optional(),
    adminPanel: z.boolean().optional(),
    designAIAssistantGuidelines: z.string().default(''),
    order: z.any(), // TODO
    updatedAt: z.string(), // TODO
    createdAt: z.string(), // TODO
});

export type User = z.infer<typeof baseUserSchema> & {
    team: Team['id'] | Team;
};

export const UserSchema = baseUserSchema.extend({
    team: z.lazy(() => z.union([TeamSchema, TeamSchema.shape.id])),
}) as z.ZodType<User>;
